import { useAppSelector } from "../../redux/hooks";
import { css } from "../../../styled-system/css";
import { useMissingTrellisAdsProfiles } from "./onboarding/MissingProfilesSections";
import { useMemo } from "react";
import { Trans, useTranslation } from "react-i18next";
import DismissibleBanner from "../core/basic/DismissibleBanner";
import { useMarketplaceLabel } from "../../utils/marketplaceConstants";

const InvalidAmazonPaymentMethodBanner = () => {
  const { t, i18n } = useTranslation(["advertising"]);
  const onboardData = useAppSelector((state) => state.amz_onboard);
  const user = useAppSelector((state) => state.user);
  const marketplaceLabel = useMarketplaceLabel();

  const profilesQuery = useMissingTrellisAdsProfiles();

  const invalidMarketplaceCodes = useMemo(() => {
    const profiles = profilesQuery.data?.profiles_with_invalid_payment_methods ?? [];
    const codes = profiles
      .filter(
        (profile) =>
          profile.accountInfo.name === user.current_profile && profile.accountInfo.type === user.organization_type,
      )
      .map((profile) => profile.countryCode);
    return [...new Set(codes)].sort();
  }, [profilesQuery.data, user.current_profile, user.organization_type]);

  const showBanner = onboardData.amazon_advertising_access === "connected" && invalidMarketplaceCodes.length > 0;

  if (!showBanner) {
    return null;
  }

  const listFormatter = new Intl.ListFormat([i18n.resolvedLanguage ?? "en", "en"], { type: "conjunction" });
  const marketplaces = listFormatter.format(invalidMarketplaceCodes.map(marketplaceLabel));

  return (
    <DismissibleBanner
      storageKey={`dismiss_invalid_amazon_payment_method_banner_${user.organization_id}_${invalidMarketplaceCodes.join("_")}`}
      dismissForDays={30}
    >
      <span>
        <Trans
          t={t}
          i18nKey={($) =>
            $.advertising[
              "Your Amazon Advertising profile's payment method is currently invalid in {marketplaces}. Please update it on the <a>Amazon Advertising console</a> to ensure your campaigns continue to serve."
            ]
          }
          values={{ marketplaces }}
          components={{
            a: (
              <a
                className={css({ color: "white", textDecoration: "underline" })}
                href={"https://advertising.amazon.com"}
                target={"_blank"}
                rel={"noopener noreferrer"}
              />
            ),
          }}
        />
      </span>
    </DismissibleBanner>
  );
};

export default InvalidAmazonPaymentMethodBanner;
